<template>
  <div class="share">
    <!-- 头部 -->
    <div class="section">
      <img src="../assets/product/header.jpg" alt="">
      <div class="title">产品与方案</div>
      <div class="content">雅格致力于用先进的数字科学技术，为行业赋能，实现行业数智化，降本增效，风险可控，合规经营！</div>
    </div>
    <!-- 内容提示 -->
    <div class="tips">
      <div>
        <img src="../assets/product/icon.png" alt="">
        <span>首页 > 产品与解决方案</span>
      </div>
    </div>
    <!-- 整体内容 -->
    <div class="main">
        <div class="main-flex">
          <div class="box">
            <div class="left">
              <p class="title">大数据BI商业智能解决方案</p>
              <p class="content">经营状况直观可视化，</p>
              <p class="content"> 数据实时同步，</p>
              <p class="content">及时查看和分析。</p>
            </div>
            <div class="right">
              <div>
                <img src="../assets/product/driver.png" alt="">
              </div>
              <div class="btn"  @click="skipUrl('/BI')">了解更多</div>
            </div>
          </div>
           <div class="box">
            <div class="left">
              <p class="title">RPA解决方案</p>
              <p class="content">机器人流程自动化，</p>
              <p class="content">替代人力，高效完成重复</p>
              <p class="content">且有逻辑性的工作。</p>
            </div>
            <div class="right">
              <div>
                <img src="../assets/product/RPA.png" alt="">
              </div>
              <div class="btn" @click="skipUrl('/RPA')">了解更多</div>
            </div>
          </div>
          <div class="box">
            <div class="left">
              <p class="title">智能银行解决方案</p>
              <p class="content">以数据为基础，以技术创新为手段，实现数字化转型，降本增效，合规经营，降低风险。</p>
             
            </div>
            <div class="right">
              <div>
                <img src="../assets/product/bank.png" alt="">
              </div>
              <div class="btn" @click="skipUrl('/bank')">了解更多</div>
            </div>
          </div>
          <div class="box">
            <div class="left">
              <p class="title">大数据智能风控解决方案</p>
              <p class="content">贷前风控、贷中预警、贷后催 收的全生命周期管理服务。 </p>
              
            </div>
            <div class="right">
              <div>
                <img src="../assets/product/risk.png" alt="">
              </div>
              <div class="btn" @click="skipUrl('/risk')">了解更多</div>
            </div>
          </div>
        </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  data() {
    return {
     

    };
  },
  mounted() {
   
    
  },
  computed: {},
  methods: {
    // 跳转页面
    skipUrl(url){
      console.log(url);
      this.$router.push(url);
    },
  },
};
</script>
<style scoped lang="scss">
.share {
  width: 100%;
  font-family: Source Han Sans CN;
  font-weight: bold;
  margin: 0;
  padding: 0;
  // 头部
  .section{
    margin: 0 0 -5px;
    position: relative;
    color: #FFFFFF;
    cursor: pointer;
    img{
      width: 100%;
      height: auto;
    }
    .title{
      position: absolute;
      top:20%;
      left: 12%;
      font-size: 24px;
    }
    // 产品内容
    .content{
      position: absolute;
      top: 35%;
      left: 12%;
      width: 35%;
      white-space: pre-wrap;
    }
  }
  // 内容提示
  .tips{
    width: 100%;
    height: 50px;
    line-height: 50px;
    cursor: pointer;
    div{
      margin-left: 12%;
      img{
      width: 12px;
      height: 12px;
      vertical-align: middle;

    }
    span{
      font-size: 10px;
      color: #808080;
      margin: 0 6px;
      display: inline-block;
      vertical-align: middle;
    }
    }
    
  }
  // 整体内容
  .main{
    width: 100%;
    height: 90vh;
    background: #F5F5FA ;
    padding-top: 40px;
    .main-flex{
      display: flex;
      justify-content: space-between;
      width: 80%;
      margin: 0 10%;
      flex-wrap: wrap;
      .box{
        width: 30%;
        height: 200px;
        background: #FFFFFF;
        border: 4px solid #FFFFFF;
        box-shadow: 2px 13px 29px 0px rgba(130, 169, 228, 0.17);
        border-radius: 16px;
        margin: 10px 0;
        padding:  40px 20px 0;
        box-sizing: border-box;
        display: flex;
        justify-content: space-around;
        // 左边内容介绍
        .left{
          width: 71%;
          cursor: pointer;
          .title{
            font-size: 20px;
            margin: 0 0 20px;
          }
          .content{
            font-size: 14px;
            color: #8D9BB9;
            margin: 5px 0;
          }
        }
        // 右边图画
        .right{
          position: relative;
           img{
            width: 3rem;
            height: auto;
            margin-left: 20px;
          }
          // 了解更多
          .btn{
            width: 85px;
            height: 30px;
            background: linear-gradient(-90deg, #135DE4, #19B7FF);
            border-radius: 23px;
            text-align: center;
            line-height: 30px;
            color: #FFFFFF;
            font-size: 14px;
            position: absolute;
            bottom: 20px;
            cursor: pointer;
          }
        }
      }
    }
  }
}
</style>
